/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useEffect, useMemo } from 'react';
import SavableDropdownField from '../../components/SavableDropdownField';
import { clearRoadblock, saveRoadblock } from '../../actions/TicketActions';
import { useAppDispatch, useAppSelector } from '../../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
const isSupported = (productArea, productAreaToRoadblock, roadblock) => roadblock && productArea && productAreaToRoadblock.has(`${productArea.id}`) && productAreaToRoadblock.get(`${productArea.id}`).includes(roadblock.id);
function RoadblockField() {
  const dispatch = useAppDispatch();
  const isSaving = useAppSelector(({
    zorseGrrTagging: state
  }) => state.actionStates.isSavingRoadblock);
  const ticket = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticket);
  const ticketExternalProperties = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticketExternalProperties);
  useEffect(() => {
    if (!isSupported(ticket.productArea, ticketExternalProperties.productAreaToRoadblocksMapping, ticket.roadblock)) {
      dispatch(clearRoadblock());
    }
  }, [dispatch, ticket, ticketExternalProperties]);
  const options = useMemo(() => ticketExternalProperties.roadblocks.filter(obj => Boolean(isSupported(ticket.productArea, ticketExternalProperties.productAreaToRoadblocksMapping, obj))).map(obj => ({
    text: obj.name,
    value: obj.id
  })).sortBy(obj => obj.text).toArray(), [ticket, ticketExternalProperties]);
  return /*#__PURE__*/_jsx(SavableDropdownField, {
    isDisabled: !ticket.productArea || !ticket.isRequiringRoadblock(ticketExternalProperties.productAreaToRoadblocksMapping),
    isRequired: Boolean(ticket.isRequiringRoadblock(ticketExternalProperties.productAreaToRoadblocksMapping)),
    isSaving: isSaving,
    labelLangPath: "app.panel.body.fields.labels.roadblock",
    onOptionSelected: id => dispatch(saveRoadblock(ticket.id, ticketExternalProperties.roadblocks.find(obj => obj.id === id))),
    options: options,
    placeholderLangPath: "app.panel.body.fields.placeholders.choose",
    value: ticket.isRequiringRoadblock(ticketExternalProperties.productAreaToRoadblocksMapping) && ticket.hasSupportedRoadblock(ticketExternalProperties.productAreaToRoadblocksMapping) && ticket.roadblock ? ticket.roadblock.id : undefined
  });
}
export default RoadblockField;